import React from 'react';
import { Navigate } from 'react-router-dom';

// This is a simple function to check for the presence of the auth token
const useAuth = () => {
  const token = localStorage.getItem('accessToken');
  // You could add token validation/decoding here in the future
  return token ? true : false;
};

const ProtectedRoute = ({ children }) => {
  const isAuthenticated = useAuth();

  if (!isAuthenticated) {
    // If not authenticated, redirect to the sign-in page
    return <Navigate to="/signin" />;
  }

  // If authenticated, render the component that was passed in
  return children;
};

export default ProtectedRoute;